import { render } from "./addDeptPo.vue?vue&type=template&id=7ed30fb0&scoped=true"
import script from "./addDeptPo.vue?vue&type=script&lang=js"
export * from "./addDeptPo.vue?vue&type=script&lang=js"

import "./addDeptPo.vue?vue&type=style&index=0&id=7ed30fb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed30fb0"]])

export default __exports__